import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CaymanIslandsFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15342'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15342)'>
				<rect
					width='20'
					height='14'
					fill='#07319C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.7626 4.66672C15.5515 4.66672 16.1911 4.24885 16.1911 3.73338C16.1911 3.21792 15.5515 2.80005 14.7626 2.80005C13.9736 2.80005 13.334 3.21792 13.334 3.73338C13.334 4.24885 13.9736 4.66672 14.7626 4.66672Z'
					fill='#FAD051'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3809 6.99994C12.3809 5.59994 12.3809 3.73328 12.3809 3.73328H17.1428C17.1428 3.73328 17.1428 5.59994 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
					fill='url(#paint0_linear_2332_15342)'
				/>
				<mask
					id='mask1_2332_15342'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='12'
					y='3'
					width='6'
					height='8'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 6.99994C12.3809 5.59994 12.3809 3.73328 12.3809 3.73328H17.1428C17.1428 3.73328 17.1428 5.59994 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15342)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 3.73328H17.1428V4.66661H15.238H14.2856H12.3809V3.73328Z'
						fill='#CF142C'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M17.1428 5.59998H12.3809V6.53331H14.2856H15.238H17.1428V5.59998ZM12.3809 7.46664H17.1428V8.39998H15.238H14.2856H12.3809V7.46664ZM12.3809 9.33331H17.1428V10.2666H15.238H14.2856H12.3809V9.33331Z'
						fill='#125FBA'
					/>
				</g>
				<path
					d='M-0.915074 -0.333333H0H0.47619H0.581265L0.667345 -0.273077L3.9146 2H4.66793L8.39732 -0.284251L8.90476 -0.595057V0V0.293115C8.90476 0.510658 8.79862 0.714517 8.6204 0.839269L5.57143 2.97355V3.578L8.45876 6.00336C8.80818 6.29688 8.60063 6.86667 8.14428 6.86667C8.04397 6.86667 7.94608 6.83581 7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828M-0.915074 -0.333333L-0.214397 0.255235L3 2.95533V3.55978L-0.191154 5.79359L-0.333333 5.89311V6.06667V6.53333V7.12839L0.174104 6.81758L3.90349 4.53333H4.65683L7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828'
					fill='#DB1E36'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.33333V4.2H3.33333V6.33333C3.33333 6.70152 3.63181 7 4 7H4.57143C4.93962 7 5.23809 6.70152 5.23809 6.33333V4.2H8.38095C8.74914 4.2 9.04762 3.90152 9.04762 3.53333V3C9.04762 2.63181 8.74914 2.33333 8.38095 2.33333H5.23809V0H3.33333V2.33333H0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H3.80952V2.33333V0H4.7619V2.33333V2.8H8.57143V3.73333H4.7619V4.2V6.53333H3.80952V4.2V3.73333H0V2.8Z'
					fill='#DB1E36'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_15342'
					x1='12.3809'
					y1='3.73328'
					x2='12.3809'
					y2='10.2666'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default CaymanIslandsFlagIcon;
